import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import AnalyticsEvents from '@/analytics/AnalyticsEvents';
import { isWorkshopParentFrontend } from '@/config';
import useVisibilityTracking from '@/hooks/useVisibilityTracking';
import { TyreReadingsResponse } from '@/services/api.types';
import AxleRow from './AxelRow';
import { groupTyresByAxle } from './utils';

const TyresGrid = ({ data }: { data: TyreReadingsResponse }) => {
    const axles = groupTyresByAxle(data.tyres);

    const trackSectionView = useCallback(() => {
        if (isWorkshopParentFrontend()) {
            return;
        }
        AnalyticsEvents.viewTyresBlock();
    }, []);

    const sectionRef = useVisibilityTracking<HTMLDivElement>(trackSectionView, 0.5, 1000);

    return (
        <div ref={sectionRef} className="display-grid" style={{ gridTemplateColumns: '1fr auto 1fr' }}>
            <span className="text-center padding-bottom-5 border border-bottom-only border-color-light">
                <FormattedMessage id="intl-msg:tyres.left" />
            </span>
            <span className="text-center padding-bottom-5 border border-bottom-only border-color-light">
                <FormattedMessage id="intl-msg:tyres.axle" />
            </span>
            <span className="text-center padding-bottom-5 border border-bottom-only border-color-light">
                <FormattedMessage id="intl-msg:tyres.right" />
            </span>

            {axles.map((axle, index) => (
                <AxleRow key={axle.position} axle={axle} assetId={data.asset_id} isLast={index === axles.length - 1} />
            ))}
        </div>
    );
};

export default TyresGrid;
